import {
  Container,
  Grid,
  Card,
  CardContent,
  Typography,
  // useMediaQuery,
  // useTheme,
} from '@material-ui/core'
import useStyle from './SkillsStyle'
import MaterialUi from '../../img/material-ui.svg'
function Skills() {
  const style = useStyle()
  // const theme = useTheme()
  // const matchMd = useMediaQuery(theme.breakpoints.down('sm'))
  return (
    <section id='skills' className={style.skillsSection}>
      <Container  style={{ width: '95%' }} maxWidth='lg'>
        <Typography  className={style.title} variant='h2'>
          Skills
        </Typography>
        <Grid spacing={5} direction='column' container>
          <Grid item>
            <Grid spacing={5} direction='row' container>
              <Grid md={4} xs={12} item>
                <Card className={style.card}>
                  <CardContent>
                    <i
                      style={{
                        fontSize: '3rem',
                        color: '#fca311',
                        marginBottom: '0.5rem',
                      }}
                      className='fab fa-html5'
                    ></i>
                    <Typography gutterBottom variant='h6'>
                      HTML
                    </Typography>
                    <Typography gutterBottom variant='subtitle1'>
                      I Can Build a Website With all The Html Elements Needed.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid md={4} xs={12} item>
                <Card className={style.card}>
                  <CardContent>
                    <i
                      style={{
                        fontSize: '3rem',
                        color: '#fca311',
                        marginBottom: '0.5rem',
                      }}
                      className='fab fa-sass'
                    ></i>
                    <Typography gutterBottom variant='h6'>
                      Scss
                    </Typography>
                    <Typography gutterBottom variant='subtitle1'>
                      I Can Style Your Page With All the Features Provided By
                      Scss, Like:{' '}
                      <span style={{ color: '#fca311' }}>
                        Nesting, Mixins, Functions.
                      </span>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid md={4} xs={12} item>
                <Card className={style.card}>
                  <CardContent>
                    <i
                      style={{
                        fontSize: '3rem',
                        color: '#fca311',
                        marginBottom: '0.5rem',
                      }}
                      className='fab fa-git-alt'
                    ></i>
                    <Typography gutterBottom variant='h6'>
                      Git/GitHub
                    </Typography>
                    <Typography gutterBottom variant='subtitle1'>
                      I have Great Team Communication Skills and I'm Good At:{' '}
                      <span style={{ color: '#fca311' }}>
                        Push Request, Branch, Create A Repository.
                      </span>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
          <Grid item>
            <Grid spacing={5} direction='row' container>
              <Grid md={4} xs={12} item>
                <Card className={style.card}>
                  <CardContent>
                    <img
                      style={{
                        width: '3rem',
                        marginBottom: '0.5rem',
                      }}
                      src={MaterialUi}
                      alt='Material-Ui'
                    />
                    <Typography gutterBottom variant='h6'>
                      Material-Ui
                    </Typography>
                    <Typography gutterBottom variant='subtitle1'>
                      I Can Combine React And Material-Ui to Make a Custom Great
                      Looking Sites.
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid md={4} xs={12} item>
                <Card className={style.card}>
                  <CardContent>
                    <i
                      style={{
                        fontSize: '3rem',
                        color: '#fca311',
                        marginBottom: '0.5rem',
                      }}
                      className='fab fa-js-square'
                    ></i>
                    <Typography gutterBottom variant='h6'>
                      JavaScript
                    </Typography>
                    <Typography gutterBottom variant='subtitle1'>
                      I Can Make an interactive Site With JS and I'm Good At:{' '}
                      <span style={{ color: '#fca311' }}>
                        Dom Manipulation, HttpRequest, Functional Programming.
                      </span>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
              <Grid md={4} xs={12} item>
                <Card className={style.card}>
                  <CardContent>
                    <i
                      style={{
                        fontSize: '3rem',
                        color: '#fca311',
                        marginBottom: '0.5rem',
                      }}
                      className='fab fa-react'
                    ></i>
                    <Typography gutterBottom variant='h6'>
                      React
                    </Typography>
                    <Typography gutterBottom variant='subtitle1'>
                      I Can Combine JS with React To Make High Interactive Web
                      Apps And I'm Good At:{' '}
                      <span style={{ color: '#fca311' }}>
                        Redux, ReactRouter, ReactHooks.
                      </span>
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </section>
  )
}

export default Skills
